/**
 * Handheld-device detection shared by capture flows that tune themselves for
 * phones and tablets (orientation prompt, camera checks, detection defaults).
 *
 * Touch support alone is never a signal: touchscreen laptops report touch
 * points but cannot be rotated.
 */

const MOBILE_UA =
  /Android|iPhone|iPad|iPod|Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i;

/** Touch-only primary input; a mouse or trackpad would report hover. */
export const TOUCH_ONLY_QUERY = '(hover: none) and (pointer: coarse)';

/**
 * @param {{ navigator?: Navigator, matchMedia?: Window['matchMedia'] }} [env]
 * @returns {boolean}
 */
export const isMobileDevice = (env = globalThis) => {
  const nav = env.navigator;
  if (!nav) return false;

  // Positive signal only: Android tablets report `mobile: false`.
  if (nav.userAgentData?.mobile === true) return true;

  const userAgent = nav.userAgent || '';
  if (MOBILE_UA.test(userAgent)) return true;

  // iPadOS requests desktop sites by default and sends a Mac UA; real Macs
  // have no touch screen.
  if (/Macintosh/.test(userAgent) && nav.maxTouchPoints > 1) return true;

  // "Request desktop site" on Android hides the mobile UA; the primary-input
  // media query still identifies the device.
  return (
    typeof env.matchMedia === 'function' &&
    env.matchMedia.call(env, TOUCH_ONLY_QUERY).matches
  );
};
